import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator([
  'UPDATE_NEXTPATH',
  'UPDATE_NEXTSTATE',
]);

export default actionTypes;



// WEBPACK FOOTER //
// app/javascript/packs/MasterApp/constants/masterAppConstants.jsx